import { render, staticRenderFns } from "./OverdueDebtorList.vue?vue&type=template&id=7ffe94ab&scoped=true&"
import script from "./OverdueDebtorList.vue?vue&type=script&lang=js&"
export * from "./OverdueDebtorList.vue?vue&type=script&lang=js&"
import style0 from "./OverdueDebtorList.vue?vue&type=style&index=0&id=7ffe94ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe94ab",
  null
  
)

export default component.exports